import React, { useState } from "react";
import {
  SiMicrosoftexcel,
  SiPowerbi,
  SiPython,
  SiTableau,
  SiMysql,
  SiMicrosoftpowerpoint,
} from "react-icons/si";

const skillData = {
  hardSkills: [
    "Microsoft Excel",
    "Power BI",
    "SQL",
    "Python",
    "Power Query",
    "Tableau",
    "Looker Studio",
    "Data Processing",
    "Data Cleaning",
    "Data Validation",
    "Data Categorization",
    "Data Transformation",
    "Data Wrangling",
    "Data Aggregation",
    "Data Analysis",
    "Exploratory Data Analysis",
    "Statistical Analysis",
    "Pattern Analysis",
    "KPI Analysis",
    "Data Interpretation",
    "Data Visualization",
    "Dashboard Development",
    "Data Modeling",
    "DAX",
    "Data Reporting",
    "Data Storytelling",
    "SQL Querying",
    "Database Management",
    "PivotTables",
    "Excel Formulas",
    "Pandas",
    "NumPy",
  ],
  softSkills: [
    "Problem Solving",
    "Team Work",
    "Adaptability",
    "Communication",
    "Time Management",
    "Willingness to Learn",
    "Responsibility",
  ],
  softwareSkills: [
    "VS Code",
    "R Studio",
    "Microsoft Office",
    "Kaggle",
    "Git",
    "Power BI",
    "Tableau",
    "PostgreSQL",
    "Figma",
    "Canva",
    "MS Excel",
  ],
};

const featuredTools = [
  {
    title: "Microsoft Excel",
    icon: SiMicrosoftexcel,
    color: "linear-gradient(135deg, #1d6f42 0%, #2ecc71 100%)",
    description: "Spreadsheet, data cleaning, and dashboard reporting",
  },
  {
    title: "Power BI",
    icon: SiPowerbi,
    color: "linear-gradient(135deg, #f2c811 0%, #ff8a00 100%)",
    description: "Interactive business dashboard and KPI visualization",
  },
  {
    title: "Tableau",
    icon: SiTableau,
    color: "linear-gradient(135deg, #e15759 0%, #ff8a80 100%)",
    description: "Storytelling dashboard with visually appealing insights",
  },
  {
    title: "Python",
    icon: SiPython,
    color: "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
    description: "Data processing, automation, and machine learning workflows",
  },
  {
    title: "SQL",
    icon: SiMysql,
    color: "linear-gradient(135deg, #0f766e 0%, #2dd4bf 100%)",
    description: "Database querying, modeling, and data analysis with SQL",
  },
  {
    title: "Microsoft PowerPoint",
    icon: SiMicrosoftpowerpoint,
    color: "linear-gradient(135deg, #d97706 0%, #fbbf24 100%)",
    description: "Presentation design and executive storytelling",
  },
];

const FeaturedToolCard = ({ tool }) => {
  const Icon = tool.icon;

  return (
    <div className="skill-feature-card">
      <div className="skill-feature-icon" style={{ background: tool.color }}>
        <Icon />
      </div>
      <h6>{tool.title}</h6>
      <p>{tool.description}</p>
    </div>
  );
};

function Skills() {
  const [activeCategory, setActiveCategory] = useState("hardSkills");
  const categories = [
    { key: "hardSkills", label: "Hard Skills" },
    { key: "softSkills", label: "Soft Skills" },
    { key: "softwareSkills", label: "Software Skills" },
  ];

  return (
    <div className="container py-5-mt4">
      <div className="skill-feature-grid mb-5">
        {featuredTools.map((tool) => (
          <FeaturedToolCard key={tool.title} tool={tool} />
        ))}
      </div>

      <div className="skill-card mb-5">
        <div className="skill-category-buttons" role="tablist" aria-label="Skill categories">
          {categories.map((category) => (
            <button
              type="button"
              role="tab"
              aria-selected={activeCategory === category.key}
              className={
                activeCategory === category.key
                  ? "skill-category-button active"
                  : "skill-category-button"
              }
              key={category.key}
              onClick={() => setActiveCategory(category.key)}
            >
              {category.label}
            </button>
          ))}
        </div>
        <p className="skill-category-list">
          {skillData[activeCategory].join(", ")}
        </p>
      </div>
    </div>
  );
}

export default Skills;
